// Leaves room in the 118px column for a two-digit percentage label beside the longest bar.
const MAX_BAR_WIDTH = 56;

interface TimeSpentBarProps {
  percent: number;
  maxPercent: number;
}

export function TimeSpentBar({ percent, maxPercent }: TimeSpentBarProps) {
  const isMax = percent > 0 && percent === maxPercent;
  const width = Math.max(2, (percent / Math.max(maxPercent, Number.EPSILON)) * MAX_BAR_WIDTH);

  return (
    <div className="flex items-center gap-2 pl-2 font-mono text-[12.5px] text-fg min-[721px]:text-[13.5px]">
      <span
        className={`h-[calc(var(--hm-row)-10px)] min-w-0.5 shrink-0 rounded-[1px] ${isMax ? 'bg-gold' : 'bg-bar'}`}
        style={{ width }}
      />
      {percent.toFixed(1)}%
    </div>
  );
}
